import i18n from '../i18n';

export const getStoredLanguage = () => localStorage.getItem('language') || 'en';

export const setStoredLanguage = (lang) => {
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
};

